<template>
    <div class="flex border-b" >
        <div class="flex flex-grow" :class="{ 'cursor-pointer' : collapseMode, 'p-4' : !collapseMode }" v-on:click="onCollapseClick">
            <div class="pt-3 pr-1" style="cursor: pointer" v-show="backurl.length > 0" v-on:click="onBackClick()">
                <font-awesome-icon icon="arrow-circle-left" class="text-xl" />
            </div>
            <div v-if="!collapseMode" class="rounded-full h-10 w-10 flex items-center justify-center" :class="color" v-on:click="onTitleClick">
                <font-awesome-icon :icon="icon" class="text-xl text-white" />
            </div>
            <div class="rounded-full h-10 w-10 flex items-center justify-center" :class="color" v-if="collapseMode">
                <font-awesome-icon icon="chevron-down" v-if="collapse === true" class="text-xl" />
                <font-awesome-icon icon="chevron-up" v-if="collapse === false" class="text-xl" />
            </div>
            <div class="flex-1 text-left text-lg font-bold pt-2 pl-2">
                <h2>{{ text }}</h2>
            </div>
            <div class="pt-2" v-if="settingsmenu.length > 0" style="cursor: pointer">
                <l-popup icon="cog" placement="right-start" class="text-lg">
                    <div class="flex flex-col m-3">
                        <div class="flex flex-col mt-1" v-for="(m, i) in settingsmenu" v-bind:key="i">
                            <label class="inline-flex text-sm" v-if="me.permissions.includes(m.permission)">
                                <input type="checkbox" :id="'chk' + m.id" class="form-checkbox h-4 w-4 text-gray-600 hover:cursor-pointer" :checked="m.checked" v-on:click="onClick(m)" />
                                <span class="ml-2 text-gray-700 self-center hover:cursor-pointer">{{ m.text }}</span>
                            </label>
                        </div>
                    </div>
                </l-popup>
            </div>
        </div>
        <div class="cursor-pointer rounded-full h-10 w-10 flex items-center justify-center" v-if="sortMode && collapse" v-on:click="onSortClick" title="flytt til toppen">
            <font-awesome-icon icon="arrow-up-right-dots" class="text-xl" />
        </div>

    </div>
</template>

<script>
    import LPopup from "@/components/LPopup";
    import UsersService from "@/helpers/services/users.service";
    import { VClosePopover } from "v-tooltip";
    //import LContainerToolbar from "./LContainerToolbar";
    export default {
        name: "LContainerTitle",
        components: { LPopup },
        props: {
            text: { default: "" },
            icon: { default: "" },
            color: { default: "" },
            settingsmenu: { default: () => [] },
            backurl: { default: "" },
            collapseMode: { default: false },
            collapse: { default: false },
            sortMode: { default: false }
        },
        directives: {
            "close-popover": VClosePopover,
        },
        data() {
            return {
                me: { permissions: [] },
            };
        },
        async created() {
            try {
                this.me = await UsersService.me();
            } catch (e) { }
        },
        methods: {
            onClick: function (m) {
                this.$emit("onSettingsEvent", m);
            },
            onBackClick: function () {
                window.location.href = decodeURI(this.backurl);
            },
            onTitleClick: function (m) {
                this.$emit("TitleIconClick", m);
            },
            onCollapseClick: function (e) {
                if (this.collapseMode)
                    this.$emit("onCollapseClick", e);
            },
            onSortClick: function (s) {
                if (this.sortMode)
                    this.$emit("onSortClick", s);
            }
        },
    };
</script>
